const a = (t, l, o = "local") => {
  let e = {};
  return t === "BANNER" ? e = {
    paginationType: "dots",
    showControls: !0,
    controlArrowSize: 72,
    controlButtonsOffset: -5.25,
    showScrollbar: !1,
    startIndex: 0,
    variableHeight: !1,
    title: l,
    autoplay: o !== "local",
    autoplayDelay: 6e3,
    showPagination: !0,
    gutterSize: 0,
    slideAspectRatio: 2.011764705882353,
    slideGap: 1.5,
    cellsPerSlide: 1,
    cellAspectRatio: 2.011764705882353,
    cellsPosition: "center",
    wrapAround: !0
  } : t === "FEATURED" ? e = {
    paginationType: "dots",
    showControls: !0,
    controlArrowSize: 64,
    controlButtonsOffset: -2,
    showScrollbar: !1,
    startIndex: 0,
    variableHeight: !1,
    title: l,
    autoplay: !1,
    autoplayDelay: 6e3,
    showPagination: !1,
    gutterSize: 0,
    slideAspectRatio: "",
    slideGap: 2.5,
    cellsPerSlide: 4,
    cellAspectRatio: 0.6561461794019934,
    cellsPosition: "flex-start",
    wrapAround: !1
  } : t === "TWO_COLUMN" && (e = {
    paginationType: "dots",
    showControls: !0,
    controlArrowSize: 64,
    controlButtonsOffset: -4.5,
    showScrollbar: !1,
    startIndex: 0,
    variableHeight: !1,
    title: l,
    autoplay: !1,
    autoplayDelay: 6e3,
    showPagination: !0,
    gutterSize: 0,
    slideAspectRatio: 2.6666666666666665,
    slideGap: 1.5,
    cellsPerSlide: 1,
    cellAspectRatio: 2.6666666666666665,
    cellsPosition: "center",
    wrapAround: !1
  }), e;
};
export {
  a as getCarouselOptions
};
